<div class="modal-dialog instructions-preview-dialog-container">
	<div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
		<div class="goreact-modal-header">
			<h4
				class="modal-title"
				translate="activity-instructions-editor-modal_preview_instructions"
				[id]="dialogTitleId"
			></h4>
			<button
				class="close-btn"
				type="button"
				[attr.aria-label]="'common_close' | translate"
				(click)="close()"
			>
				<i class="ficon-app-x"></i>
			</button>
		</div>

		<div class="goreact-modal-body">
			<rich-instructions [instruction]="data.instruction"></rich-instructions>
		</div>

		<div class="goreact-modal-footer">
			<button
				class="primary-btn"
				type="button"
				(click)="close()"
				translate="common_close"
			></button>
		</div>
	</div>
</div>
